import React, { useState, useEffect } from 'react'
import { IoSearch } from "react-icons/io5";
import icon05 from "../../../studentassets/images/icons/05.svg"
import icon01 from "../../../studentassets/images/icons/01.svg"
import { useSelector } from 'react-redux';
import { selectMode } from '../../../service/slice/ThemeSlice';
import Loading from '../../Loading';
import { ToastContainer, toast, } from "react-toastify";
import { useNavigate } from 'react-router-dom';

export default function RightSidebar() {

    const [rightSideToggle, setRightSideToggle] = useState(false);
    const [loading, setLoading] = useState(true);
    const [history, setHistory] = useState([])
    const theme = useSelector(selectMode);
    const usertoken = localStorage.getItem('authToken')
    const navigate = useNavigate()

    const themeColor = {
        color: theme === 'light' ? '#000' : '#fff',
        background: theme === 'light' ? '#fff' : '#151A24',
        boxShadow: theme === 'light' ? '#fff' : 'rgb(186 189 217 / 20%)',
    };

    const fetchMyHistory = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getRecentSearchHistory`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${usertoken}`
            },
        });
        return response.json();
    };

    useEffect(() => {
        try {
            fetchMyHistory().then((data) => {
                if (data.status) {
                    setHistory(data.history)
                } else {
                    toast.success(data?.msg ? data?.msg : 'Something went erong please try again later.');
                }
                setLoading(false)
            })
        } catch (error) {
            setLoading(false)
            toast.error("Something went erong please try again later.");
        }
    }, [])
    const date = new Date();
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    return (
        <>
            {loading ?
                <Loading />
                :
                <div className={`${rightSideToggle && "right-side-bar-new-chat-option-open"} right-side-bar-new-chat-option`} style={themeColor}>
                    {/* <div className="chat-history-area-start" style={{ height: "50px" }}>
                    <div className="input-group" style={{ height: "50px" }}>
                        <span className="input-group-text">
                            <IoSearch style={{ fontSize: "20px" }} />
                            <input type="text" placeholder="Search..." className='search-input' />
                        </span>

                    </div>
                </div> */}
                    <div className="chat-history-wrapper">
                        <div className="chat-history-area-start">
                            <h6 className="title pb-2" style={{...themeColor, borderBottom: "1px solid #E5E4FF"}}>This Month ({months[date.getMonth()]})</h6>
                            {history.map((data, index) => {
                                return <div key={index} className="single-history">
                                    <p style={themeColor}>{data?.question? data?.question : 'Asked by photo or file'}</p>
                                    <i class="fa-solid fa-eye" onClick={()=>{navigate('/user/questionview', { state: data })}}></i>
                                </div>
                            })}

                        </div>
                    </div>


                    <button className="right-side-open-clouse" id="collups-right" onClick={() => { setRightSideToggle(!rightSideToggle) }}>
                        <img src={icon01} alt="icons" />
                    </button>

                </div>}

        </>
    )
}
